module.exports = __webpack_public_path__ + "img/ICON3.8d24d6f2.png";